// extracted by mini-css-extract-plugin
export var button = "_dg-0";
export var donut = "_dg-1";
export var donutFill = "_dg-3";
export var donutTrack = "_dg-2";